import { DropdownOption } from 'components/atoms/Dropdown/Dropdown';
import { AlgoSourceMapping } from 'interfaces/algoSourceMapping';
import { map } from 'lodash';

export interface StudyAlgorithmExecutionCopy {
  selectionStepLabel: string;
  selectionInstruction: string;
  emptyStateText: string;
  waitingForStartText: (algorithmDisplayName: string) => string;
  startedText: (algorithmDisplayName: string) => string;
}

const defaultStudyAlgorithmExecutionCopy: StudyAlgorithmExecutionCopy = {
  selectionStepLabel: 'Select Algorithm',
  selectionInstruction: 'Select an algorithm to run',
  emptyStateText: 'No algorithms available',
  waitingForStartText: (algorithmDisplayName: string) => `Waiting for ${algorithmDisplayName} to start`,
  startedText: (algorithmDisplayName: string) => `${algorithmDisplayName} Started`,
};

export const getStudyAlgorithmDisplayName = (algorithm?: Partial<AlgoSourceMapping> | null) =>
  algorithm?.displayName || algorithm?.sourceLocator || 'Study Algorithm';

export const buildStudyAlgorithmJobName = (
  algorithm?: Partial<AlgoSourceMapping> | null,
  currentTime: Date = new Date()
) => `${getStudyAlgorithmDisplayName(algorithm)} - ${currentTime.toLocaleString()}`;

export const getStudyAlgorithmOptions = (availableAlgorithms: AlgoSourceMapping[] = []): DropdownOption[] =>
  map(availableAlgorithms, (algorithm) => ({
    value: algorithm.id,
    text: getStudyAlgorithmDisplayName(algorithm),
  }));

export const getStudyAlgorithmExecutionCopy = (): StudyAlgorithmExecutionCopy => defaultStudyAlgorithmExecutionCopy;
